// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dNy2W","name":"styles_name__3ALFT","phone":"styles_phone__2dQso"};